import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface LegalNewsItem {
  _id: string;
  url: string;
  title: string;
  summary: string;
  source: string;
  sourceLabel: string;
  publishedAt: string;
  scrapedAt: string;
  language: string;
  jurisdiction: string;
}

export interface LegalNewsState {
  items: LegalNewsItem[];
  loading: boolean;
  error: string | null;
  fetchedAt: string | null;
}

const initialState: LegalNewsState = {
  items: [],
  loading: false,
  error: null,
  fetchedAt: null,
};

const legalNewsSlice = createSlice({
  name: 'legalNews',
  initialState,
  reducers: {
    fetchLegalNewsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchLegalNewsSuccess(state, action: PayloadAction<{ items: LegalNewsItem[], fetchedAt: string }>) {
      state.items = action.payload.items;
      state.fetchedAt = action.payload.fetchedAt;
      state.loading = false;
      state.error = null;
    },
    fetchLegalNewsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchLegalNewsStart, fetchLegalNewsSuccess, fetchLegalNewsFailure } = legalNewsSlice.actions;

export default legalNewsSlice.reducer;
